"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTermType = asTermType;
function asTermType(type) {
    if (type === 'namedNode' || type === 'literal' || type === 'blankNode' || type === 'quad') {
        return type;
    }
    return undefined;
}
//# sourceMappingURL=Expressions.js.map